export default __webpack_public_path__ + "static/media/Slide5.eb415f57.jpg";